import '@eonasdan/tempus-dominus/dist/css/tempus-dominus.css';
import * as tempusDominus from './_tempus-dominus.js';

const elements = document.getElementsByClassName('js_component_datepicker');

function isDateValid(date) {
    return !isNaN(new Date(date));
}

for (let element of elements) {
    new tempusDominus.TempusDominus(element, {
        hooks: {
            inputParse: (context, value) => {
                if (!value) return '';
                const date = new Date(value);
                return isDateValid(date) ? tempusDominus.DateTime.convert(date) : '';
            },
            inputFormat: (context, date) => { 
                if (!date || !isDateValid(date)) {
                    return '';
                }
                const year = date.getFullYear();
                const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
                const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
                const hours = (date.getHours() < 10 ? '0' : '') + date.getHours();
                const minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
                const seconds = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
        },

        display: {
            icons: {
                time: 'bi bi-clock',
                date: 'bi bi-calendar',
                up: 'bi bi-arrow-up',
                down: 'bi bi-arrow-down',
                next: 'bi bi-arrow-right',
                previous: 'bi bi-arrow-left',
                clear: 'bi bi-trash'
            },
        },

        localization: {
            today: 'Перейти сегодня',
            clear: 'Очистить выделение',
            close: 'Закрыть сборщик',
            selectMonth: 'Выбрать месяц',
            previousMonth: 'Предыдущий месяц',
            nextMonth: 'В следующем месяце',
            selectYear: 'Выбрать год',
            previousYear: 'Предыдущий год',
            nextYear: 'В следующем году',
            selectDecade: 'Выбрать десятилетие',
            previousDecade: 'Предыдущее десятилетие',
            nextDecade: 'Следующее десятилетие',
            previousCentury: 'Предыдущий век',
            nextCentury: 'Следующий век',
            pickHour: 'Выберите час',
            incrementHour: 'Время увеличения',
            decrementHour: 'Уменьшить час',
            pickMinute: 'Выбрать минуту',
            incrementMinute: 'Минута приращения',
            decrementMinute: 'Уменьшить минуту',
            pickSecond: 'Выбрать второй',
            incrementSecond: 'Увеличение секунды',
            decrementSecond: 'Уменьшение секунды',
            toggleMeridiem: 'Переключить период',
            selectTime: 'Выбрать время',
            selectDate: 'Выбрать дату',
            dayViewHeaderFormat: {month: 'long', year: '2-digit'},
            locale: 'ru',
            startOfTheWeek: 1
        }
    }); 
}